export default __webpack_public_path__ + "locales/sq-AL/SMTPSettings.json?hash=684a0787139747b61370415ab85f4682";